import { UseCase } from "../../useCase"
import { UpdateSurveySectionResponse } from "./response"
import { UpdateSurveySectionRequest } from "./request"
import { SurveyRepository } from "../../../repositories/surveyRepository"

export class UpdateSurveySectionUseCase implements UseCase<UpdateSurveySectionRequest, UpdateSurveySectionResponse> {
	private _repository
	constructor({ SurveyRepository }: { SurveyRepository: SurveyRepository }) {
		this._repository = SurveyRepository
	}

	exec(surveySection: UpdateSurveySectionRequest) {
		return this._repository.updateSurveySection(surveySection)
	}
}
